import React from 'react';
import cn from 'classnames';
import styles from './ReactionList.module.scss';

const Reaction = ({ count, renderIcon }) => {
  return (
    <li
      className={cn(styles.reaction, {
        [styles.default]: count === 0,
        [styles.active]: count > 0,
      })}
    >
      {typeof renderIcon === 'function' && renderIcon({className: styles.icon})}
      <p className={styles.count}>{count}</p>
    </li>
  );
};

export default Reaction;
